import axios from "../customize_axios"

export const postReview = async (token, reviewDetail) => {
    try {
        const response = await axios.post(
            "api/order/review",
            reviewDetail,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("Post Review: ", error.response)
        return error.response.data;
    }
}

export const getReviewsForBook = async (bookID, page) => {
    try {
        const response = await axios.get(`api/book/${bookID}/review?page=${page}`)
        return response.data
    } 
    catch (error) { 
        console.log("getReviewsForBook", error.response)
    }

}

export const getRatingPercent = async (bookID) => {
    try {
        const response = await axios.get(`api/book/${bookID}/rating-percent`)
        return response.data
    } 
    catch (error) {
        console.log("getRatingPercent", error.response ? error.response.data : error.message)
    }
}